import React, { useState } from "react";
import styles from "./ReservationManagement.module.css";

const ReservationManagement = () => {
    const [isYearly, setIsYearly] = useState(false);

    return (
        <div className={styles.container}>
            {/* ===== Header ===== */}
            {/* <header className={styles.header}>
        <div className={styles.logo}>TBox</div>
        <nav>
          <ul className={styles.navList}>
            <li>Product</li>
            <li>About Us</li>
            <li>Sign Up</li>
            <li className={styles.signIn}>Sign In</li>
          </ul>
        </nav>
      </header> */}

            {/* ===== Hero ===== */}
            <section className={styles.hero}>
                <h1>
                    AI Appointment & Reservation Management <br />
                    Schedule Instantly, Stress-Free
                </h1>
                <p>
                    Revolutionize your scheduling with our AI-powered booking system.
                    Manage appointments, reservations, and consultations efficiently—all
                    in real-time.
                </p>
                <button className={styles.primaryBtn}>Book Your Appointment Now</button>
            </section>

            {/* ===== Introduction ===== */}
            <section className={styles.introduction}>
                <h2>Introduction</h2>
                <p>
                    Our AI booking agent is designed for businesses, professionals, and
                    individuals who want seamless reservation management. Say goodbye to
                    scheduling conflicts and endless back-and-forth emails.
                </p>
            </section>

            {/* ===== How It Works ===== */}
            <section className={styles.howItWorks}>
                <h2>How It Works</h2>
                <div className={styles.steps}>
                    {[
                        {
                            title: "Client Details",
                            text: "Enter your name, email, and phone.",
                        },
                        {
                            title: "Select Appointment",
                            text: "Select type of appointment, service, or reservation.",
                        },
                        {
                            title: "Select Date and Time",
                            text: "Choose an available date and time.",
                        },
                        {
                            title: "Confirmation",
                            text: "Confirm instantly and receive notifications via email or SMS.",
                        },
                    ].map((step, i) => (
                        <div key={i} className={styles.step}>
                            <img
                                src={`https://via.placeholder.com/250x150?text=Step+${i + 1}`}
                                alt={step.title}
                            />
                            <h3>{i + 1}. {step.title}</h3>
                            <p>{step.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ===== Features ===== */}
            <section className={styles.features}>
                <h2>Key Features</h2>
                <div className={styles.featureGrid}>
                    {[
                        "24/7 Online Booking",
                        "Real-Time Calendar Integration",
                        "Automated Email & SMS Reminders",
                        "Easy Rescheduling & Cancellation",
                        "Multi-Platform Access",
                        "Customizable Booking Forms",
                    ].map((feature, i) => (
                        <div key={i} className={styles.featureCard}>
                            {feature}
                        </div>
                    ))}
                </div>
            </section>

            {/* ===== Experience ===== */}
            <section className={styles.experience}>
                <h2>Experience Instant Booking</h2>
                <p>
                    Instantly book appointments or reserve spots without calls or emails.
                    Select your service, pick a date and time, and let AI handle the rest.
                </p>
                <button className={styles.primaryBtn}>Select Plan</button>
            </section>

            {/* ===== Testimonials ===== */}
            <section className={styles.testimonials}>
                <h2>Loved by Professionals</h2>
                <div className={styles.testimonialGrid}>
                    {[
                        {
                            quote:
                                "The AI system saves us hours every week. Our reservations are now hassle-free!",
                            name: "Raj P., Restaurant Manager",
                        },
                        {
                            quote:
                                "I never miss a client appointment thanks to instant reminders and confirmations.",
                            name: "Sarah M., Therapist",
                        },
                        {
                            quote:
                                "The real-time integration with my calendar is a game-changer.",
                            name: "Varun D., Freelancer",
                        },
                    ].map((t, i) => (
                        <div key={i} className={styles.testimonial}>
                            <p>“{t.quote}”</p>
                            <span>- {t.name}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* ===== FAQ ===== */}
            <section className={styles.faq}>
                <h2>Frequently Asked Questions</h2>
                {[
                    "Can I reschedule an appointment?",
                    "Is my data secure?",
                    "Can I integrate it with my existing calendar?",
                    "Can I use it for multiple locations?",
                ].map((q, i) => (
                    <div key={i} className={styles.faqItem}>
                        {q}
                    </div>
                ))}
            </section>

            {/* ===== Pricing ===== */}
            <section className={styles.pricing}>
                <h2>Simple, Transparent Pricing</h2>
                <div className={styles.toggle}>
                    <button
                        className={!isYearly ? styles.active : ""}
                        onClick={() => setIsYearly(false)}
                    >
                        Monthly
                    </button>
                    <button
                        className={isYearly ? styles.active : ""}
                        onClick={() => setIsYearly(true)}
                    >
                        Yearly
                    </button>
                </div>

                <div className={styles.planGrid}>
                    {[
                        { title: "Basic Plan", price: isYearly ? "190" : "19", highlight: false },
                        { title: "Pro Plan", price: isYearly ? "390" : "39", highlight: true },
                        { title: "Enterprise Plan", price: isYearly ? "590" : "59", highlight: false },
                    ].map((plan, i) => (
                        <div
                            key={i}
                            className={`${styles.planCard} ${plan.highlight ? styles.highlight : ""
                                }`}
                        >
                            <h3>{plan.title}</h3>
                            <h4>${plan.price} /mo</h4>
                            <ul>
                                <li>Includes all key features</li>
                                <li>AI-powered booking</li>
                                <li>Priority support</li>
                            </ul>
                            <button>Select Plan</button>
                        </div>
                    ))}
                </div>
            </section>

            {/* ===== Footer ===== */}
            {/* <footer className={styles.footer}>
                <h3>Start Scheduling Smarter Today</h3>
                <p>
                    Don’t waste time with manual scheduling. Let our AI Appointment &
                    Reservation Agent manage your bookings efficiently.
                </p>
                <div>
                    <button className={styles.primaryBtn}>Book Now</button>
                    <button className={styles.secondaryBtn}>Learn More</button>
                </div>
                <div className={styles.footerBottom}>
                    <p>© 2025 TBox. All Rights Reserved.</p>
                </div>
            </footer> */}
        </div>
    );
};

export default ReservationManagement;
